import { Star, Sparkles, Check, X, MessageSquareReply } from "lucide-react";

function Stars({ rating }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: 5 }).map((_, index) => (
        <Star
          key={index}
          size={15}
          className={
            index < rating
              ? "fill-yellow-400 text-yellow-400"
              : "text-slate-300"
          }
        />
      ))}
    </div>
  );
}

export default function ReviewCard({
  name = "",
  date,
  rating,
  review,
  responseText,
  suggestedResponse,
  status = "needs_response",
}) {
  const initials =
    name
      ?.split(" ")
      .filter(Boolean)
      .map((part) => part[0])
      .join("")
      .toUpperCase() || "?";

  const hasResponse = Boolean(responseText);

  return (
    <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-4 sm:p-5 space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
        <div className="flex gap-3 min-w-0">
          <div className="h-10 w-10 sm:h-11 sm:w-11 rounded-full bg-slate-200 flex items-center justify-center font-semibold text-slate-700 shrink-0 text-sm">
            {initials}
          </div>

          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
              <h3 className="font-semibold text-slate-900 truncate">{name}</h3>

              <span className="hidden sm:inline text-xs text-slate-400">•</span>

              <span className="text-sm text-slate-500">{date}</span>
            </div>

            <div className="mt-1">
              <Stars rating={rating} />
            </div>
          </div>
        </div>

        {hasResponse ? (
          <span className="w-fit bg-green-100 text-green-700 text-xs font-medium px-3 py-1 rounded-full">
            Responded
          </span>
        ) : (
          status === "needs_response" && (
            <span className="w-fit bg-orange-100 text-orange-700 text-xs font-medium px-3 py-1 rounded-full">
              Needs Response
            </span>
          )
        )}
      </div>

      <p className="text-sm sm:text-base text-slate-700 leading-relaxed">
        {review}
      </p>

      {hasResponse && (
        <div className="bg-green-50 border border-green-100 rounded-2xl p-4 space-y-2">
          <div className="flex items-center gap-2 text-green-700 font-semibold text-sm">
            <MessageSquareReply size={16} />
            Owner Response
          </div>

          <p className="text-sm sm:text-base text-slate-700 leading-relaxed">
            {responseText}
          </p>
        </div>
      )}

      {!hasResponse && suggestedResponse && (
        <div className="bg-indigo-50 border border-indigo-100 rounded-2xl p-4 space-y-3">
          <div className="flex items-center gap-2 text-indigo-700 font-semibold text-sm">
            <Sparkles size={16} />
            Suggested Response
          </div>

          <p className="text-sm sm:text-base text-slate-700 leading-relaxed">
            {suggestedResponse}
          </p>

          <div className="grid grid-cols-1 sm:flex sm:flex-wrap gap-2 pt-1">
            <button className="w-full sm:w-auto justify-center bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2.5 rounded-xl text-sm font-medium flex items-center gap-2 transition">
              <Check size={16} />
              Approve
            </button>

            <button className="w-full sm:w-auto border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 px-4 py-2.5 rounded-xl text-sm font-medium transition">
              Edit
            </button>

            <button className="w-full sm:w-auto justify-center border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 px-4 py-2.5 rounded-xl text-sm font-medium flex items-center gap-2 transition">
              <X size={16} />
              Reject
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
